<template>
  <div id="appeals" class="col-12 block-shadow mt-4">
    <div class="row">
      <div class="col-12 mb-4" v-if="measurements">
        <h3 class="table-title">{{'report.data_appeals' | trans }}</h3>
        <p class="table-subtitle">{{'report.summary_table_requests' | trans
          }}</p>

        <div class="appeals-list">
          <div v-for="appeal in appeals" class="radio-btn">
            {{appeal.text}} ({{appeal.count}})
          </div>
        </div>

        <p class="table-subtitle">{{'appeals.appeals_count' | trans }}</p>

        <bar-chart :linedatasets="lineChartDataset"
                   :bardatasets="barChartDataset"
                   :height=null
                   :width=null
                   v-bind:show-legend="true"/>
      </div>

    </div>
  </div>

</template>

<script>
  import apiAppeals from '../../appeals/api/appeals';
  import {mapActions, mapGetters, mapState} from 'vuex';
  import Loader from '../../loader/components/Loader';
  import isEmpty from 'lodash/isEmpty';
  import cloneDeep from 'lodash/cloneDeep';
  import Constants from '../../undesirableBehavior/Constants';
  import {
    BarChart,
    BarChartDataset,
    LineChartDataset,
  } from '../../../common/chart';
  import forEach from 'lodash/forEach';
  import lang from '../../../lang/translator';
  import moment from 'moment';
  import {pagination} from '../../../common/mixins/pagination';

  export default {
    props: {
      'clientId': {
        type: [Number, String],
        default() {
          return Auth.getUserInfo().id || this.route.params.clientId;
        },
      },
      'changeData': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'clientTimezone': {
        type: [String],
        default() {
          return null;
        },
      },
      'rangeDateStart': {
        type: [Date],
        default() {
          return new Date();
        },
      },
      'rangeDateEnd': {
        type: [Date],
        default() {
          return new Date();
        },
      },
    },
    data() {
      return {
        apiUrl: 'appeals/statistics/',
        isModalVisible: false,
        isEditModalVisible: false,
        measurements: null,
        formats: {
          title: 'MMMM YYYY',
          weekdays: 'WW',
          navMonths: 'MMM',
          input: ['DD MMM YYYY'],
          dayPopover: 'L',
          data: ['DD MMM YYYY'],
        },
        appeals: null,
      };
    },

    components: {
      Loader, BarChart,
    },
    mixins: [pagination],

    computed: {
      ...mapState(['route']),
      ...mapGetters('mobile', [
        'isMobile',
      ]),
      isEmptyAppeals: function() {
        return isEmpty(this.appeals);
      },
      lineChartDataset() {
        return this.fetchDatasetForChart();
      },
      barChartDataset() {
        return this.fetchBarDatasetForChart();
      },
      rangeDateStartTimestamp() {
        return moment(this.rangeDateStart).unix() +
            (Math.abs(this.rangeDateEnd.getTimezoneOffset()) *
                Constants.SECONDS_PER_MINUTE);
      },
      rangeDateEndTimestamp() {
        return moment(this.rangeDateEnd).unix() +
            (Math.abs(this.rangeDateEnd.getTimezoneOffset()) *
                Constants.SECONDS_PER_MINUTE);
      },
    },

    created() {
      if (this.clientTimezone) {
        this.setDate();
      }
    },

    methods: {
      toLocaleDate: function(date) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YY');
      },

      fetchMeasurement: async function() {
        try {
          let response = await apiAppeals.getCountAppeals(
              this.clientId,
              this.rangeDateStartTimestamp,
              this.rangeDateEndTimestamp,
          );

          this.measurements = response.data.data;

        } catch (error) {
          console.dir(error);
        }
      },

      fetchDatasetForChart() {
        let data = [];
        let i = 0;
        let label = lang.get('appeals.avarage_appeals_perhour');
        forEach(this.measurements, (item) => {
          data.push(
              {
                x: i,
                y: item.perHourCount,
              },
          );
          i++;
        });

        return new LineChartDataset({
          data, label,
        });

      },
      fetchBarDatasetForChart() {
        let data = [];
        let i = 0;
        let label = lang.get('appeals.total_appeals_perday');
        let labels = [];
        forEach(this.measurements, (item) => {
          data.push(
              {
                x: i,
                y: item.totalCount,
              },
          );
          i++;
          labels.push(this.toLocaleDate(item.dateRange.end));

        });

        return new BarChartDataset({data, label, labels});
      },

      setDate() {
        this.getPageAppeals(
            this.clientId,
            this.rangeDateStartTimestamp,
            this.rangeDateEndTimestamp,
        );
        this.fetchMeasurement();
      },

      getPageAppeals: async function(clientId, startDate, endDate) {
        let response = await apiAppeals.getCountAllAppeals(clientId, startDate,
            endDate);
        this.appeals = response.data.data;
      },

      getDateTimestamp(date) {
        return moment(date).unix() +
            (Math.abs(date.getTimezoneOffset()) * Constants.SECONDS_PER_MINUTE);
      },

    },

    watch: {
      rangeDateStart(oldValue, newValue) {
        let rangeDays = Constants.MILLISECONDS * Constants.SECONDS *
            Constants.MINUTES * Constants.HOURS * Constants.COUNT_DAY;
        if (!oldValue) {
          this.rangeDateStart = newValue;
        }
        let myDate = cloneDeep(this.rangeDateStart);
        let newDate = new Date(myDate.getTime() + rangeDays);

        if (newDate.getTime() / Constants.MILLISECONDS >
            moment.tz(new Date(), this.clientTimezone).
                utcOffset(0, true).
                unix()) {
          this.rangeDateEnd = moment().
              tz(this.clientTimezone).
              add(-(moment().utcOffset()), 'm')._d;
        }
        else {
          this.rangeDateEnd = newDate;
        }
      },
      changeData() {
        this.setDate();
      },
      clientTimezone() {
        if (this.clientTimezone) {
          this.setDate();
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/modules/reports/components/DataAppeals.vue